// Hounddale PDP interactions. Scoped to .pdp-page container. Reused verbatim by the real
// PDP (main-product-pdp.liquid) and by the Quick Buy drawer (quick-buy-content.liquid,
// injected at runtime by quick-shop.js) via window.HounddalePDP.initPdp(root).
(function(){
  function money(cents, format){
    var n = (cents/100);
    if (!format) return '$' + n.toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, n.toFixed(2)).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n));
  }

  function widthUrl(src, width){
    if (!src) return src;
    var cleaned = src.replace(/([?&])width=\d+(&|$)/, function(_, pre, post){ return post ? pre : ''; }).replace(/[?&]$/, '');
    var sep = cleaned.indexOf('?') === -1 ? '?' : '&';
    return cleaned + sep + 'width=' + width;
  }

  // Urgency copy — mirrors the server-side rule in snippets/pdp-urgency.liquid so client-side
  // variant switches never contradict the initial server render. Real Shopify-tracked low
  // stock (when it exists) always wins and is always truthful. Otherwise this leaves the
  // server-rendered simulated scarcity count (product-level, not variant-level) alone rather
  // than recomputing it — recomputing here would mean duplicating the seeded-random logic in
  // JS for no benefit, since switching color/size shouldn't change how many are "left."
  function updateUrgency(root, v){
    var el = root.querySelector('[data-pdp-urgency]');
    if (!el || !v) return;
    if (!v.available) { el.hidden = true; return; }
    el.hidden = false;
    var threshold = parseInt(el.getAttribute('data-pdp-urgency-threshold'), 10) || 10;
    var textEl = el.querySelector('[data-pdp-urgency-text]');
    var dotEl = el.querySelector('[data-pdp-urgency-dot]');
    var tracked = v.inventory_management === 'shopify';
    var qty = v.inventory_quantity;
    var isLow = tracked && typeof qty === 'number' && qty > 0 && qty <= threshold;
    if (isLow) {
      if (textEl) textEl.textContent = 'Only ' + qty + ' left in stock';
      el.classList.add('pdp-urgency--low');
      if (dotEl) dotEl.classList.add('is-low');
    } else {
      var simText = el.getAttribute('data-pdp-urgency-sim-text');
      var simLow = el.getAttribute('data-pdp-urgency-sim-low') === 'true';
      if (textEl && simText) textEl.textContent = simText;
      el.classList.toggle('pdp-urgency--low', simLow);
      if (dotEl) dotEl.classList.toggle('is-low', simLow);
    }
  }

  function initPdp(root){
    if (!root || root.dataset.pdpReady) return;
    root.dataset.pdpReady = '1';

    var data = null;
    try { data = JSON.parse(root.querySelector('[data-pdp-product-json]').textContent); }
    catch(e){ console.warn('[pdp] no product json'); return; }
    var format = root.dataset.moneyFormat || '${{amount}}';

    var state = { options: {} };
    var optionNames = data.options || [];

    var initial = data.variants.find(function(v){ return v.id == root.dataset.selectedVariant; })
                || data.variants.find(function(v){ return v.available; })
                || data.variants[0];
    if (initial) optionNames.forEach(function(n, i){ state.options[n] = initial.options[i]; });

    var isInitialRender = true;

    function findVariant(){
      return data.variants.find(function(v){
        return optionNames.every(function(n, i){ return v.options[i] === state.options[n]; });
      });
    }

    function updateUI(){
      var v = findVariant();
      root.querySelectorAll('[data-pdp-option]').forEach(function(btn){
        var name = btn.dataset.pdpOption; var val = btn.dataset.pdpValue;
        var isActive = state.options[name] === val;
        btn.classList.toggle('is-active', isActive);
        var testOpts = Object.assign({}, state.options); testOpts[name] = val;
        var candidate = data.variants.find(function(x){ return optionNames.every(function(n, i){ return x.options[i] === testOpts[n]; }); });
        btn.disabled = !(candidate && candidate.available);
      });
      root.querySelectorAll('[data-pdp-selected]').forEach(function(el){
        el.textContent = state.options[el.dataset.pdpSelected] || '';
      });
      if (v) {
        var priceEl = root.querySelector('[data-pdp-price]');
        var compareEl = root.querySelector('[data-pdp-compare]');
        var saveEl = root.querySelector('[data-pdp-save]');
        var atcPrice = root.querySelector('[data-pdp-atc-price]');
        var atcBtn = root.querySelector('[data-pdp-atc]');
        var stickyPrice = root.querySelector('[data-pdp-sticky-price]');
        if (priceEl) priceEl.textContent = money(v.price, format);
        if (compareEl) compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, format) : '';
        if (saveEl) {
          if (v.compare_at_price > v.price) {
            var savedAmt = v.compare_at_price - v.price;
            // Integer-truncated to match Liquid's `divided_by` (integer division, floors)
            // exactly — NOT Math.round — so the % shown here after a client-side variant
            // change always matches what the server would have rendered for that same
            // variant. Using round here previously could show one point higher than the
            // server-rendered value shoppers first saw.
            var pct = Math.floor(savedAmt * 100 / v.compare_at_price);
            saveEl.textContent = 'Save ' + money(savedAmt, format) + ' · ' + pct + '% off';
            saveEl.style.display = '';
          } else {
            saveEl.style.display = 'none';
          }
        }
        if (atcPrice) atcPrice.textContent = '— ' + money(v.price, format);
        if (atcBtn) {
          atcBtn.disabled = !v.available;
          var label = atcBtn.firstElementChild;
          var text = v.available ? 'Add to Bag' : 'Sold out';
          if (label && label.tagName === 'SPAN') { label.textContent = text; } else { atcBtn.textContent = text; }
        }
        if (stickyPrice) stickyPrice.textContent = money(v.price, format);

        // Quick Buy's Buy Now button lives outside the eyebrow/price/atc block set above.
        var buyBtn = root.querySelector('[data-qb-buy]');
        if (buyBtn) buyBtn.disabled = !v.available;

        updateUrgency(root, v);

        // Jump the gallery to this variant's linked image on click, routed through the same
        // goToMedia()/thumbs/currentIdx system the thumbnail strip and arrows use — not a
        // direct main.src swap — so the active thumbnail highlight and arrow/keyboard/swipe
        // navigation all stay in sync with whatever image is actually showing after a variant
        // change. Matching is by media id (data-pdp-media-id on each thumb) rather than by
        // src string, since it's stable regardless of image transform/width params.
        if (!isInitialRender && v.featured_media) {
          var targetMediaId = String(v.featured_media.id);
          var matchIdx = -1;
          for (var ti = 0; ti < thumbs.length; ti++) {
            if (thumbs[ti].dataset.pdpMediaId === targetMediaId) { matchIdx = ti; break; }
          }
          if (matchIdx !== -1) {
            goToMedia(matchIdx);
            syncLightboxImage();
          } else if (v.featured_media.preview_image) {
            // Fallback for markup that hasn't been updated with data-pdp-media-id yet, or a
            // media id that isn't in the thumbnail strip for some reason — still swap the
            // main image directly so the shopper sees the right photo either way.
            var main = root.querySelector('[data-pdp-main-img]');
            if (main) {
              var newSrc = widthUrl(v.featured_media.preview_image.src, 1400);
              if (newSrc && newSrc !== main.getAttribute('src')) {
                main.src = newSrc;
                main.alt = v.featured_media.alt || (data.title || '');
                main.style.display = '';
                var ph = root.querySelector('[data-pdp-main-ph]'); if (ph) ph.style.display = 'none';
                syncLightboxImage();
              }
            }
          }
        }

        try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); } catch(e){}
        var vin = root.querySelector('[data-pdp-variant-input]'); if (vin) vin.value = v.id;

        // Lets containers outside this root (e.g. Quick Buy's sticky mobile purchase bar,
        // which lives in the static drawer shell, not inside the injected .pdp-page) react to
        // variant changes without pdp.js needing to know anything about them.
        if (!isInitialRender && root.dispatchEvent) {
          try { root.dispatchEvent(new CustomEvent('pdp:variantchange', { bubbles: true, detail: { variant: v } })); } catch(e){}
        }
      }
      isInitialRender = false;
    }

    root.querySelectorAll('[data-pdp-option]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.disabled) return;
        state.options[btn.dataset.pdpOption] = btn.dataset.pdpValue;
        updateUI();
      });
    });

    root.querySelectorAll('[data-pdp-mode]').forEach(function(btn){
      btn.addEventListener('click', function(){
        root.querySelectorAll('[data-pdp-mode]').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    var qtyInput = root.querySelector('[data-pdp-qty]');
    root.querySelectorAll('[data-pdp-qty-inc]').forEach(function(b){ b.addEventListener('click', function(){ qtyInput.value = Math.max(1, (parseInt(qtyInput.value)||1) + 1); }); });
    root.querySelectorAll('[data-pdp-qty-dec]').forEach(function(b){ b.addEventListener('click', function(){ qtyInput.value = Math.max(1, (parseInt(qtyInput.value)||1) - 1); }); });

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var currentIdx = 0;

    function goToMedia(idx){
      if (thumbs.length === 0) return;
      currentIdx = ((idx % thumbs.length) + thumbs.length) % thumbs.length;
      var t = thumbs[currentIdx];
      var src = t.dataset.pdpThumb; if (!src) return;
      var main = root.querySelector('[data-pdp-main-img]');
      if (main) { main.src = src; main.style.display = ''; }
      var ph = root.querySelector('[data-pdp-main-ph]'); if (ph) ph.style.display = 'none';
      thumbs.forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
    }

    thumbs.forEach(function(t, i){
      t.addEventListener('click', function(){ goToMedia(i); });
    });

    var prevBtn = root.querySelector('[data-pdp-gallery-prev]');
    var nextBtn = root.querySelector('[data-pdp-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); goToMedia(currentIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); goToMedia(currentIdx + 1); });

    var frame = root.querySelector('.pdp-frame');
    if (frame) {
      frame.setAttribute('tabindex', '0');
      frame.addEventListener('keydown', function(e){
        if (e.key === 'ArrowLeft') { e.preventDefault(); goToMedia(currentIdx - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); goToMedia(currentIdx + 1); }
      });

      // Swipe between images on touch — single finger only. Listeners are passive (no
      // preventDefault) so they never block native scrolling or two-finger pinch-zoom.
      var touchStartX = null, touchStartY = null, touchActive = false;
      frame.addEventListener('touchstart', function(e){
        if (e.touches.length !== 1) { touchActive = false; return; }
        touchActive = true;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      frame.addEventListener('touchend', function(e){
        if (!touchActive || touchStartX === null) return;
        var t = (e.changedTouches && e.changedTouches[0]) || null;
        var endX = t ? t.clientX : touchStartX;
        var endY = t ? t.clientY : touchStartY;
        var dx = endX - touchStartX, dy = endY - touchStartY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          if (dx < 0) goToMedia(currentIdx + 1); else goToMedia(currentIdx - 1);
        }
        touchActive = false; touchStartX = null; touchStartY = null;
      }, { passive: true });
    }

    // ---------------------------------------------------------------------
    // Zoom lightbox — desktop gets wheel-zoom + click/drag pan; touch devices
    // are left to the browser's own native pinch-zoom + pan (we never call
    // preventDefault on touch events here).
    // ---------------------------------------------------------------------
    var lightbox = root.querySelector('[data-pdp-lightbox]');
    var lbStage = root.querySelector('[data-pdp-lightbox-stage]');
    var lbImg = root.querySelector('[data-pdp-lightbox-img]');
    var lbClose = root.querySelector('[data-pdp-lightbox-close]');
    var lbPrev = root.querySelector('[data-pdp-lightbox-prev]');
    var lbNext = root.querySelector('[data-pdp-lightbox-next]');
    var zoomBtn = root.querySelector('.pdp-frame__zoom');

    var zoomState = { scale: 1, tx: 0, ty: 0, min: 1, max: 4 };

    function applyZoom(){
      if (!lbImg) return;
      lbImg.style.transform = 'translate(' + zoomState.tx + 'px,' + zoomState.ty + 'px) scale(' + zoomState.scale + ')';
    }

    function resetZoom(){
      zoomState.scale = 1; zoomState.tx = 0; zoomState.ty = 0;
      applyZoom();
      if (lbStage) lbStage.classList.remove('is-zoomed');
    }

    function clampPan(){
      if (!lbImg || !lbStage) return;
      var stageRect = lbStage.getBoundingClientRect();
      var imgRect = lbImg.getBoundingClientRect();
      var overflowX = Math.max(0, (imgRect.width - stageRect.width) / 2);
      var overflowY = Math.max(0, (imgRect.height - stageRect.height) / 2);
      zoomState.tx = Math.max(-overflowX, Math.min(overflowX, zoomState.tx));
      zoomState.ty = Math.max(-overflowY, Math.min(overflowY, zoomState.ty));
    }

    function syncLightboxImage(){
      if (!lbImg || !lightbox || lightbox.hidden) return;
      var main = root.querySelector('[data-pdp-main-img]');
      if (!main || !main.getAttribute('src')) return;
      lbImg.src = widthUrl(main.getAttribute('src'), 2000);
      lbImg.alt = main.alt || '';
      resetZoom();
    }

    function openLightbox(){
      if (!lightbox) return;
      lightbox.hidden = false;
      var main = root.querySelector('[data-pdp-main-img]');
      if (main && lbImg) {
        lbImg.src = widthUrl(main.getAttribute('src'), 2000);
        lbImg.alt = main.alt || '';
      }
      resetZoom();
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onLbKeydown);
    }

    function closeLightbox(){
      if (!lightbox) return;
      lightbox.hidden = true;
      resetZoom();
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onLbKeydown);
    }

    function onLbKeydown(e){
      if (e.key === 'Escape') { closeLightbox(); }
      else if (e.key === 'ArrowLeft') { goToMedia(currentIdx - 1); syncLightboxImage(); }
      else if (e.key === 'ArrowRight') { goToMedia(currentIdx + 1); syncLightboxImage(); }
    }

    if (zoomBtn) zoomBtn.addEventListener('click', function(e){ e.preventDefault(); openLightbox(); });
    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    if (lightbox) lightbox.addEventListener('click', function(e){ if (e.target === lightbox) closeLightbox(); });
    if (lbPrev) lbPrev.addEventListener('click', function(){ goToMedia(currentIdx - 1); syncLightboxImage(); });
    if (lbNext) lbNext.addEventListener('click', function(){ goToMedia(currentIdx + 1); syncLightboxImage(); });

    if (lbStage) {
      // Mouse-wheel zoom (desktop). Touch devices don't fire wheel events, so this never
      // interferes with mobile pinch-zoom.
      lbStage.addEventListener('wheel', function(e){
        if (!lightbox || lightbox.hidden) return;
        e.preventDefault();
        var delta = e.deltaY < 0 ? 0.22 : -0.22;
        var next = Math.max(zoomState.min, Math.min(zoomState.max, zoomState.scale + delta));
        zoomState.scale = next;
        if (next <= 1) { zoomState.tx = 0; zoomState.ty = 0; lbStage.classList.remove('is-zoomed'); }
        else { lbStage.classList.add('is-zoomed'); }
        clampPan();
        applyZoom();
      }, { passive: false });

      // Click-drag pan — gated to pointerType 'mouse' so touch input always falls through to
      // the browser's native pinch/pan handling instead.
      var dragging = false, startX = 0, startY = 0, startTx = 0, startTy = 0;
      lbStage.addEventListener('pointerdown', function(e){
        if (e.pointerType !== 'mouse' || zoomState.scale <= 1) return;
        dragging = true;
        startX = e.clientX; startY = e.clientY;
        startTx = zoomState.tx; startTy = zoomState.ty;
        lbStage.classList.add('is-dragging');
        try { lbStage.setPointerCapture(e.pointerId); } catch(err){}
      });
      lbStage.addEventListener('pointermove', function(e){
        if (!dragging) return;
        zoomState.tx = startTx + (e.clientX - startX);
        zoomState.ty = startTy + (e.clientY - startY);
        clampPan();
        applyZoom();
      });
      function endDrag(){
        if (!dragging) return;
        dragging = false;
        lbStage.classList.remove('is-dragging');
      }
      lbStage.addEventListener('pointerup', endDrag);
      lbStage.addEventListener('pointerleave', endDrag);
    }

    updateUI();

    // Prefetch full-size gallery images during idle time so clicking a thumbnail or gallery
    // arrow swaps the main image instantly instead of waiting on a fresh network request —
    // by the time the shopper clicks, the browser already has it cached. Runs after the
    // critical first paint (idle callback / short timeout fallback) so it never competes
    // with the visible hero image or other above-the-fold resources.
    if (thumbs.length > 1) {
      var prefetchGallery = function(){
        thumbs.forEach(function(t){
          var src = t.dataset.pdpThumb;
          if (src) { var pre = new Image(); pre.src = src; }
        });
      };
      if ('requestIdleCallback' in window) requestIdleCallback(prefetchGallery, { timeout: 2000 });
      else setTimeout(prefetchGallery, 800);
    }
  }

  function boot(){
    // Safety net: if a Theme Editor section reload swaps out DOM while a lightbox was open,
    // make sure we never leave the page permanently scroll-locked.
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.querySelectorAll('.pdp-page').forEach(initPdp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);

  // Exposed so assets/quick-shop.js can run this exact same controller against the
  // server-rendered Quick Buy fragment it injects into the drawer — same variant, price,
  // gallery, zoom and urgency logic as the real PDP, with zero duplicated code.
  window.HounddalePDP = { initPdp: initPdp };
})();

// ---------------------------------------------------------------------------
// Thumbnail row scrolling — desktop mouse drag, wheel-to-horizontal, and keeping
// the active thumbnail in view. Additive only: it never touches the gallery's own
// click / variant / zoom logic above. Touch and trackpad scrolling remain the
// browser's native horizontal scrolling on .pdp-thumbs (overflow-x:auto).
// Bound per row (idempotent) so the real PDP and the Quick Buy drawer's injected
// copy of the same markup both work, with no duplicate listeners.
// ---------------------------------------------------------------------------
(function(){
  if (window.__hdThumbScroll) return;
  window.__hdThumbScroll = true;

  var DRAG_THRESHOLD = 5;      // px of movement before a press becomes a drag
  var suppressClick = false;   // swallow the click that follows a real drag

  function maxScroll(row){ return row.scrollWidth - row.clientWidth; }
  function canScroll(row){ return maxScroll(row) > 1; }

  // A drag must never also "click" a thumbnail. Capture phase runs before the
  // thumbnails' own click handlers, so those never see the drag-release click.
  document.addEventListener('click', function(e){
    if (suppressClick && e.target.closest && e.target.closest('.pdp-thumbs')) {
      e.preventDefault();
      e.stopPropagation();
      suppressClick = false;
    }
  }, true);

  function bindRow(row){
    if (!row || row.dataset.hdThumbScroll) return;
    row.dataset.hdThumbScroll = '1';

    // ---- mouse drag (touch is left to native scrolling) --------------------
    var down = false, dragging = false, startX = 0, startLeft = 0;

    row.addEventListener('dragstart', function(e){ e.preventDefault(); }); // no native image drag

    row.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse' || e.button !== 0 || !canScroll(row)) return;
      down = true; dragging = false; startX = e.clientX; startLeft = row.scrollLeft;
      document.addEventListener('pointermove', onMove);
      document.addEventListener('pointerup', onUp);
      document.addEventListener('pointercancel', onUp);
    });

    function onMove(e){
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        dragging = true;
        row.classList.add('is-dragging');
      }
      row.scrollLeft = startLeft - dx;
      e.preventDefault();
    }

    function onUp(){
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onUp);
      if (dragging) {
        row.classList.remove('is-dragging');
        suppressClick = true;
        setTimeout(function(){ suppressClick = false; }, 0);
      }
      down = false; dragging = false;
    }

    // ---- mouse wheel over the row -> horizontal, smoothed -------------------
    var wheelTarget = null, raf = 0;

    function glide(){
      var cur = row.scrollLeft, diff = wheelTarget - cur;
      if (Math.abs(diff) < 1) { row.scrollLeft = wheelTarget; wheelTarget = null; raf = 0; return; }
      var step = diff * 0.22;
      if (Math.abs(step) < 1) step = diff > 0 ? 1 : -1;
      row.scrollLeft = cur + step;
      raf = requestAnimationFrame(glide);
    }

    row.addEventListener('wheel', function(e){
      if (e.ctrlKey || !canScroll(row)) return;
      if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;   // trackpad / sideways wheel: native
      var unit = e.deltaMode === 1 ? 16 : (e.deltaMode === 2 ? row.clientWidth : 1);
      var base = wheelTarget !== null ? wheelTarget : row.scrollLeft;
      var next = Math.max(0, Math.min(maxScroll(row), base + e.deltaY * unit));
      // Already at that end? Let the page scroll normally instead of trapping the wheel.
      if (next === base && wheelTarget === null) return;
      e.preventDefault();
      wheelTarget = next;
      if (!raf) raf = requestAnimationFrame(glide);
    }, { passive: false });

    // ---- keep the active thumbnail visible ----------------------------------
    // Arrows / keyboard / swipe on the main image / variant changes all move the
    // .is-active class; nudge only THIS row (never the page) so it's on screen.
    function reveal(t){
      var r = row.getBoundingClientRect(), b = t.getBoundingClientRect(), pad = 10, left = null;
      if (b.left < r.left + pad) left = row.scrollLeft - (r.left + pad - b.left);
      else if (b.right > r.right - pad) left = row.scrollLeft + (b.right - (r.right - pad));
      if (left !== null) row.scrollTo({ left: Math.max(0, Math.min(maxScroll(row), left)), behavior: 'smooth' });
    }
    new MutationObserver(function(muts){
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.classList && t.classList.contains('pdp-thumb') && t.classList.contains('is-active')) { reveal(t); break; }
      }
    }).observe(row, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  function scan(root){
    (root || document).querySelectorAll('.pdp-thumbs').forEach(bindRow);
  }

  scan();
  document.addEventListener('DOMContentLoaded', function(){ scan(); });
  document.addEventListener('shopify:section:load', function(){ scan(); });
  // Rows injected later (Quick Buy drawer) get bound as they appear.
  new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes.forEach(function(n){
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('.pdp-thumbs')) bindRow(n); else if (n.querySelectorAll) scan(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
